exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-preview-container[data-v-4b9c9376],.pdf-preview-container[data-v-4b9c9376]{height:calc(90vh - 2rem - 44px);overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b9c9376","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/documents/FilePreview.vue
// module id = 635
// module chunks = 38